var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGretaThinkingMark = function SvgGretaThinkingMark(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 200 200",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "greta-thinking-mark_svg__a",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14d9c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e44ec"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#greta-thinking-mark_svg__a)",
    d: "M0 71.609A23.57 23.57 0 0 1 9.78 52.5L86.143 4.478a23.68 23.68 0 0 1 27.714 0l76.363 48.023A23.57 23.57 0 0 1 200 71.61v116.417c0 6.613-5.373 11.974-12 11.974H12c-6.627 0-12-5.361-12-11.974z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    ref: ref
  }, props), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#greta-thinking-mark_svg__a)",
    d: "M200 100c0 55.228-44.772 100-100 100S0 155.228 0 100 44.772 0 100 0s100 44.772 100 100"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 207.959 200",
    ref: ref
  }, props), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#greta-thinking-mark_svg__a)",
    d: "M90.634 4.336a22.7 22.7 0 0 1 26.69 0l81.274 59.049a22.7 22.7 0 0 1 8.248 25.384l-31.044 95.543A22.7 22.7 0 0 1 154.209 200H53.749a22.705 22.705 0 0 1-21.592-15.688L1.113 88.769A22.7 22.7 0 0 1 9.36 63.385z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    ref: ref
  }, props), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#greta-thinking-mark_svg__a)",
    d: "M0 100C0 44.772 44.772 0 100 0s100 44.772 100 100v93.798a6.2 6.2 0 0 1-6.202 6.202H6.202A6.2 6.2 0 0 1 0 193.798z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 205.063 200",
    ref: ref
  }, props), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#greta-thinking-mark_svg__a)",
    d: "M25.317 53.164c0 4.761.938 9.303 2.641 13.45C11.978 70.05 0 84.26 0 101.267c0 16.699 11.549 30.701 27.095 34.454a35.4 35.4 0 0 0-1.778 11.116c0 19.574 15.868 35.443 35.443 35.443 4.772 0 9.324-.943 13.48-2.653C79.903 191.665 92.143 200 106.329 200s26.426-8.335 32.09-20.375a35.3 35.3 0 0 0 13.48 2.654c19.574 0 35.443-15.869 35.443-35.443a35.3 35.3 0 0 0-2.654-13.48c12.04-5.663 20.375-17.903 20.375-32.09 0-14.556-8.774-27.062-21.322-32.518a35.3 35.3 0 0 0 3.601-15.584c0-19.574-15.869-35.443-35.443-35.443-4.773 0-9.325.943-13.48 2.654C132.755 8.335 120.516 0 106.329 0c-14.186 0-26.426 8.335-32.09 20.375a35.3 35.3 0 0 0-13.48-2.654c-19.574 0-35.442 15.869-35.442 35.443"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 223.795",
    ref: ref
  }, props), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#greta-thinking-mark_svg__a)",
    d: "M88.453 3.094a23.1 23.1 0 0 1 23.094 0l76.906 44.402a23.1 23.1 0 0 1 11.547 20v88.803a23.1 23.1 0 0 1-11.547 20l-76.906 44.402a23.1 23.1 0 0 1-23.094 0l-76.906-44.402a23.09 23.09 0 0 1-11.547-20V67.496c0-8.251 4.402-15.875 11.547-20z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    ref: ref
  }, props), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#greta-thinking-mark_svg__a)",
    d: "M0 100C0 44.772 44.772 0 100 0s100 44.772 100 100v100H100C44.772 200 0 155.228 0 100"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    ref: ref
  }, props), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#greta-thinking-mark_svg__a)",
    d: "M151.405 151.405C149.906 178.495 127.464 200 100 200s-49.906-21.505-51.405-48.595C21.505 149.906 0 127.464 0 100s21.505-49.906 48.595-51.405C50.094 21.505 72.535 0 100 0c27.464 0 49.906 21.505 51.405 48.595C178.495 50.094 200 72.535 200 100c0 27.464-21.505 49.906-48.595 51.405"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGretaThinkingMark);
export default ForwardRef;